import styled from 'styled-components'

export const Copyright = styled.div``
